import React from 'react'
import Homehero from '../components/home/Homehero'
import FeaturesSection from '../components/home/FeaturesSection'
import TwoImagesSection from '../components/home/TwoImagesSection'
import BestSellingProducts from '../components/home/BestSellingProducts'
import CtaSection from '../components/home/CtaSection'
import WhyInvestSection from '../components/home/WhyInvestSection'
import ShopByMatType from '../components/home/ShopByMatType'
import FaqSection from '../components/home/FaqSection'
import HomeGallerySection from '../components/home/HomeGallerySection'
import SEO from '../components/seo/SEO'

export default function Home() {
  return (
    <>
      <SEO
        title="Custom Logo Mats Johannesburg | Premium Branded Entrance Mats South Africa"
        description="Get high-quality Custom Logo Mats in Johannesburg with ultra-fast 2–3 day local delivery. Enhance your brand with durable, heavy-duty mats. Request a free quote today!"
        keywords="custom logo mats Johannesburg, branded door mats South Africa, entrance mats Gauteng, corporate mats Sandton, logo door mats SA, branded entrance mats, premium mats Johannesburg, commercial mats South Africa"
        url="https://www.logobrandeddoormats.co.za/"
        image="https://www.logobrandeddoormats.co.za/images/sectionimages/HOMEHERO.jpeg"
      />

      {/* LocalBusiness / Store Schema for Google Local Pack & Map Snippets */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': ['LocalBusiness', 'Store'],
            name: 'Logo Branded Door Mats Johannesburg',
            image: 'https://www.logobrandeddoormats.co.za/images/sectionimages/HOMEHERO.jpeg',
            logo: 'https://www.logobrandeddoormats.co.za/logo192.png',
            '@id': 'https://www.logobrandeddoormats.co.za/#organization',
            url: 'https://www.logobrandeddoormats.co.za/',
            telephone: '+27810634772',
            email: 'care@logobrandeddoormats.co.za',
            priceRange: 'R1250 - R5865',
            address: {
              '@type': 'PostalAddress',
              streetAddress: 'Unit 31, The Foundry, No 12 Power Avenue and Cnr Isando Rd',
              addressLocality: 'Isando, Kempton Park',
              addressRegion: 'Gauteng',
              postalCode: '1600',
              addressCountry: 'ZA',
            },
            geo: {
              '@type': 'GeoCoordinates',
              latitude: -26.1362,
              longitude: 28.2162,
            },
            openingHoursSpecification: [
              {
                '@type': 'OpeningHoursSpecification',
                dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'],
                opens: '08:00',
                closes: '17:00',
              },
            ],
            areaServed: [
              { '@type': 'City', name: 'Johannesburg' },
              { '@type': 'City', name: 'Pretoria' },
              { '@type': 'City', name: 'Sandton' },
              { '@type': 'City', name: 'Midrand' },
              { '@type': 'City', name: 'Kempton Park' },
              { '@type': 'State', name: 'Gauteng' },
            ],
            sameAs: [
              'https://www.facebook.com/logobrandeddoormatssa',
              'https://www.instagram.com/logobrandeddoormats/',
              'https://www.linkedin.com/company/logo-branded-door-mats-johannesburg',
            ],
          }),
        }}
      />

      {/* FAQPage Schema for Google FAQ Rich Snippets */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'FAQPage',
            mainEntity: [
              {
                '@type': 'Question',
                name: 'What is your standard lead time for delivery in Johannesburg?',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: 'Typically, delivery takes just 2–3 business days from final design approval. We pride ourselves on having the fastest turnaround in the South African matting industry.',
                },
              },
              {
                '@type': 'Question',
                name: 'Where are you located?',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: 'You can find our showroom and production unit at Unit 31, The Foundry, No 12 Power Avenue and Cnr Isando Rd, Isando, Kempton Park. We serve commercial customers across Johannesburg, Pretoria, Sandton, Midrand, and Gauteng.',
                },
              },
              {
                '@type': 'Question',
                name: 'What file format do you need for my logo?',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: 'We prefer vector formats like .AI, .EPS, or high-resolution PDFs. We can also work with high-resolution JPGs or PNGs and provide a free digital design proof before production.',
                },
              },
              {
                '@type': 'Question',
                name: 'What payment methods do you accept?',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: 'We accept secure EFT payments in South African Rand (ZAR) and all major credit cards. A 50% deposit is required to confirm, with the remaining balance due prior to dispatch.',
                },
              },
            ],
          }),
        }}
      />

      <Homehero />
      <TwoImagesSection />
      <FeaturesSection />
      <BestSellingProducts />
      <CtaSection />
      <WhyInvestSection />
      <ShopByMatType />
      <HomeGallerySection />
      <FaqSection />
    </>
  )
}
